import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function PhotoLightbox({ open, onOpenChange, checkin, onInvalidated, canInvalidate = true }) {
    const [busy, setBusy] = useState(false);
    if (!checkin) return null;

    const invalidate = async () => {
        if (!window.confirm("Invalidar esse check-in? A tarefa volta a ficar pendente para a criança refazer.")) return;
        setBusy(true);
        try {
            await api.delete(`/checkins/${checkin.id}`);
            toast.success("Check-in invalidado");
            onOpenChange(false);
            onInvalidated?.();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Erro ao invalidar check-in");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-lg" data-testid="photo-lightbox">
                <DialogHeader>
                    <DialogTitle>{checkin.task_title || "Comprovante da tarefa"}</DialogTitle>
                </DialogHeader>
                <img
                    src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${checkin.photo_path}`}
                    alt="Comprovante da tarefa"
                    className="w-full max-h-[65vh] rounded-xl object-contain bg-black/5"
                    crossOrigin="use-credentials"
                    data-testid="lightbox-photo"
                />
                <DialogFooter className="sm:justify-between gap-2">
                    <Button variant="ghost" onClick={() => onOpenChange(false)}>Fechar</Button>
                    {canInvalidate && (
                        <Button
                            variant="destructive"
                            onClick={invalidate}
                            disabled={busy}
                            data-testid="invalidate-checkin-button"
                        >
                            {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <Trash2 className="h-4 w-4 mr-1.5" />}
                            Invalidar check-in
                        </Button>
                    )}
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
